import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { sdk } from '@/services/sdk';
import { PageHeader } from '@/components/kit';
import { BackLink } from '@/components/record';
import DiscountForm, { blankDiscount } from '@/components/admin/DiscountForm';
import { committed, logActivity } from '@/shared/data';

export const route = { path: '/admin/discounts/new', layout: 'owner', access: "['Admin_c','Staff_c'].includes(profile)" };

export default function NewDiscount() {
  const navigate = useNavigate();
  const [initial] = useState(blankDiscount);
  const [saving, setSaving] = useState(false);

  async function create(payload) {
    setSaving(true);
    try {
      const res = await sdk.table('discount_codes_c').create(payload);
      const saved = committed(res, 'Code created');
      if (!saved) return;
      logActivity('Code', `Created ${payload.Name}`, payload.Name);
      navigate(saved.Id ? `/admin/discounts/${saved.Id}` : '/admin/discounts');
    } finally {
      setSaving(false);
    }
  }

  return (
    <div className="mx-auto max-w-5xl">
      <BackLink to="/admin/discounts" label="Back to Discount codes" />
      <PageHeader eyebrow="Discount codes" title="New code" description="Codes apply at checkout before the invoice goes out." />
      <DiscountForm initial={initial} onSubmit={create} saving={saving} submitLabel="Create code" busyLabel="Creating…" cancelTo="/admin/discounts" />
    </div>
  );
}
